// extracted by mini-css-extract-plugin
export default {"page":"PageNotFound_page__ocKPr"};